/**
 * Regex pattern for allowed characters in name fields
 * Allows: letters (a-z, A-Z), numbers (0-9), and special characters: !\"#$%&'()*+,-./:;?@[]_ `~
 */
export const ALLOWED_CHARACTERS_REGEX = /^[a-zA-Z0-9!"#$%&'()*+,\-.\/:;?@\[\]\\_ `~]*$/

/**
 * Validates that a value contains only allowed characters
 * @param value The string to validate
 * @returns true if valid, false if contains invalid special characters
 */
export const hasAllowedCharacters = (value: string | null | undefined): boolean => {
  if (!value) return true;
  return ALLOWED_CHARACTERS_REGEX.test(value);
};
